"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getComputedStyles_1 = require("./getComputedStyles");
var getTagOfNode_1 = require("./getTagOfNode");
var moveChildNodes_1 = require("./moveChildNodes");
function changeElementTag(element, newTag) {
    var _a;
    if (!element || !newTag) {
        return null;
    }
    var origianlTag = (0, getTagOfNode_1.default)(element);
    if (origianlTag == newTag.toUpperCase()) {
        // Already in the target tag, no need to change
        return element;
    }
    var newElement = element.ownerDocument.createElement(newTag);
    for (var i = 0; i < element.attributes.length; i++) {
        var attr = element.attributes[i];
        newElement.setAttribute(attr.name, attr.value);
    }
    (0, moveChildNodes_1.default)(newElement, element);
    if (origianlTag == 'P' || (0, getTagOfNode_1.default)(newElement) == 'P') {
        _a = (0, getComputedStyles_1.default)(element, [
            'margin-top',
            'margin-bottom',
        ]), newElement.style.marginTop = _a[0], newElement.style.marginBottom = _a[1];
    }
    if (element.parentNode) {
        element.parentNode.replaceChild(newElement, element);
    }
    return newElement;
}
exports.default = changeElementTag;
//# sourceMappingURL=changeElementTag.js.map